import { render, staticRenderFns } from "./EstablishmentInternalOrderViewGlobal.vue?vue&type=template&id=2644b442"
import script from "./EstablishmentInternalOrderViewGlobal.vue?vue&type=script&lang=js"
export * from "./EstablishmentInternalOrderViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports